import { Form, Formik } from 'formik';
import React from 'react';
import { PrimaryButton } from '../../../../../../CommonComponents/Button';
import { IncludeExcludeMenu } from '../../../../../../CommonComponents/IncludeExcludeMenu';
import { AssetClass } from '../../../types';
import { BottomNavigation, StepBody, StepContent, SectionTitle } from '../styles';

interface SelectAssetClassesProps {
  assetClasses: AssetClass[];
  next: (assetClasses: AssetClass[]) => void;
}

export const SelectAssetClasses: React.FC<SelectAssetClassesProps> = ({ assetClasses, next }) => {
  return (
    <StepBody>
      <Formik
        onSubmit={({ assetClasses: updatedAssetClasses }) => {
          next(
            updatedAssetClasses.map(({ name, ...assetClass }) => ({
              originalName: name,
              ...assetClass,
            })),
          );
        }}
        initialValues={{
          assetClasses: assetClasses.map(({ originalName, ...assetClass }) => ({
            name: originalName,
            ...assetClass,
          })),
        }}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <StepContent>
              <SectionTitle>Custom Asset Classes</SectionTitle>

              <IncludeExcludeMenu
                items={values.assetClasses}
                onChange={v => setFieldValue('assetClasses', v)}
                includedTitle="Included Asset Classes"
                excludedTitle="Excluded Asset Classes"
                renderErrorMessage={itemsWithError =>
                  `${itemsWithError.map(({ name }) => name).join(', ')} ${
                    itemsWithError.length > 1 ? 'are' : 'is'
                  } a required asset class and cannot be excluded`
                }
              />
            </StepContent>
            <BottomNavigation>
              <PrimaryButton type="submit">Next</PrimaryButton>
            </BottomNavigation>
          </Form>
        )}
      </Formik>
    </StepBody>
  );
};
